import { WorkoutModel } from './WorkoutModel';

export class DayWeekWorkoutModel {
    constructor(workoutData) {
        const workout = this.getWorkout(workoutData);

        this._workout = {
            id: workoutData.id,
            date: workoutData.date,
            workout,
        };
    }

    get workout() {
        return this._workout;
    }

    getWorkout(workoutData) {
        let workout;

        if (workoutData.workout) {
            const workoutModel = new WorkoutModel(workoutData.workout.data);
            workout = { ...workoutModel._workout };
        }

        return workout;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/DayWeekWorkoutModel.js